"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalTexts = void 0;
var parameters_1 = __importDefault(require("@/config/parameters"));
var BaseView_1 = require("../BaseView");
var LegalTexts = /** @class */ (function (_super) {
    __extends(LegalTexts, _super);
    function LegalTexts() {
        var _this = _super.call(this) || this;
        // TODO: Translate all texts
        _this.defaultLanguage = 'en';
        _this.templateHtml = '';
        return _this;
    }
    LegalTexts.prototype.getTemplateFromHttpRequest = function (templateName) {
        return this.$httpService.get(parameters_1.default.cdn.host + "/html/" + templateName + "/" + this.defaultLanguage + "/template.html", {});
    };
    return LegalTexts;
}(BaseView_1.BaseView));
exports.LegalTexts = LegalTexts;
